import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import DepartmentEdit       from "./DepartmentEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Department List
 * @returns {React.ReactElement}
 */
function DepartmentList() {
    const { fetch, load } = useList("ticketDepartment");

    const data = Store.useState("ticketDepartment");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("ticketDepartment");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "ticketDepartmentID", elemID, "name");

    return <Main>
        <Header message="TICKET_DEPARTMENTS_NAME" icon="department">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="TICKET_DEPARTMENTS_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"                message="TICKET_DEPARTMENTS_SINGULAR" isTitle />
                    <TableHeader field="ticketAreaName"      message="TICKET_AREAS_SINGULAR"       />
                    <TableHeader field="activityName"        message="ACTIVITIES_SINGULAR"         />
                    <TableHeader field="credentialFirstName" message="TICKET_DEPARTMENTS_ASSIGNED" />
                    <TableHeader field="status"              message="GENERAL_STATUS"              align="center" maxWidth="100" />
                    <TableHeader field="mainPosition"        message="GENERAL_POSITION"            maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.ticketDepartmentID} elemID={elem.ticketDepartmentID}>
                        <TableCell message={elem.name}           />
                        <TableCell message={elem.ticketAreaName} />
                        <TableCell message={elem.activityName}   />
                        <TableCell message={elem.credentialName} />
                        <TableCell message={elem.statusName}     textColor={elem.statusColor} />
                        <TableCell message={elem.mainPosition}   />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="TICKET_DEPARTMENTS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="TICKET_DEPARTMENTS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <DepartmentEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="TICKET_DEPARTMENTS_DELETE_TITLE"
            message="TICKET_DEPARTMENTS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default DepartmentList;
